module.exports = __webpack_public_path__ + "img/zhentou.cd0a2826.png";